var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.09,
    height: 22.09,
    viewBox: "0 0 22.09 22.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sunny_FILL0_wght400_GRAD0_opsz48",
    d: "M13.045,5.765a.73.73,0,0,1-.753-.753V2.753a.753.753,0,1,1,1.506,0V5.012a.73.73,0,0,1-.753.753ZM18.191,7.9a.728.728,0,0,1,0-1.054l1.581-1.607a.758.758,0,0,1,1.079,0,.728.728,0,0,1,0,1.054L19.245,7.9a.728.728,0,0,1-1.054,0Zm2.887,5.9a.753.753,0,1,1,0-1.506h2.259a.753.753,0,1,1,0,1.506ZM13.045,24.09a.73.73,0,0,1-.753-.753V21.078a.753.753,0,1,1,1.506,0v2.259a.73.73,0,0,1-.753.753ZM6.845,7.9,5.238,6.318a.758.758,0,0,1,0-1.079.728.728,0,0,1,1.054,0L7.9,6.845A.728.728,0,0,1,7.9,7.9a.785.785,0,0,1-.54.2A.7.7,0,0,1,6.845,7.9ZM19.8,20.852l-1.607-1.607a.728.728,0,0,1,0-1.054.7.7,0,0,1,.515-.2.785.785,0,0,1,.54.2l1.632,1.581a.7.7,0,0,1,.213.54.838.838,0,0,1-.213.54.758.758,0,0,1-1.079,0ZM2.753,13.8a.753.753,0,1,1,0-1.506H5.012a.753.753,0,1,1,0,1.506Zm2.485,7.054a.728.728,0,0,1,0-1.054l1.607-1.607a.7.7,0,0,1,.515-.2.785.785,0,0,1,.54.2.758.758,0,0,1,0,1.079L6.318,20.852a.758.758,0,0,1-1.079,0Zm7.807-1.782A6,6,0,0,1,7.02,13.045,6,6,0,0,1,13.045,7.02a6,6,0,0,1,6.025,6.025,6,6,0,0,1-6.025,6.025Zm0-1.506a4.5,4.5,0,0,0,4.518-4.518,4.5,4.5,0,0,0-4.518-4.518,4.5,4.5,0,0,0-4.518,4.518,4.5,4.5,0,0,0,4.518,4.518Z",
    transform: "translate(-2 -2)",
    fill: "#868686"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.725c7a7a6f84e569e83c8ba031cf4ecb.svg";
export { ForwardRef as ReactComponent };